<template>
  <div class="whitelabel-conmission-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-date"></i> whitelabel comission</span
        >
      </div>
      <div>
        <div class="search-area">
          <el-form :inline="true" size="medium">
            <el-form-item label="Currency">
              <el-select
                v-model="currency"
                placeholder="Currenct"
                style="width:100px"
              >
                <el-option value="GBP" label="GBP"></el-option>
                <el-option value="EUR" label="EUR"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="From">
              <el-date-picker
                v-model="start_date"
                type="date"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                style="width: 160px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="To">
              <el-date-picker
                v-model="end_date"
                type="date"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                style="width: 160px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="View">
              <el-checkbox v-model="allagent">All agent</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getComissionWhitelabel()"
                >Search</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <el-row :gutter="12">
          <el-col :span="6">
            <el-card class="card-total" shadow="never">
              <div class="total">Income : <span>{{ totalIncomeInSession }}</span></div> </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="card-total" shadow="never">
              <div class="total">Comission : <span>{{ totalComissionInSession }}</span></div> </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="card-total" shadow="never">
              <div class="total">AB Profit : <span>{{ totalABProfitInSession }}</span></div> </el-card>
          </el-col>
        </el-row>

        <el-table v-loading="loading" :data="tableData" border>
          <el-table-column
            sortable
            prop="date"
            label="Date"
            width="160"
            header-align="center"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="transactionID"
            label="Transaction"
            min-width="200"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="comission_transactionID"
            label="Comission"
            header-align="center"
            align="left"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            prop="comission"
            label="Comission"
            header-align="center"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="income"
            label="Income"
            header-align="center"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="abprofit"
            label="AB Profit"
            header-align="center"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            header-align="center"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'active' ? '' : 'info'">
                {{ scope.row.status.toUpperCase() }}</el-tag
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination-comission"
          @size-change="setPageSize"
          @current-change="setPage"
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItem"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { comissionWhitelabel } from "@/api/report";
import { currentDateTime, dateFormat } from "@/utils";

export default {
  props: {
    company: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  watch: {
    company() {
      this.getComissionWhitelabel()
    },
  },
  data() {
    return {
      start_date: currentDateTime("YYYY-MM-DD"),
      end_date: currentDateTime("YYYY-MM-DD"),
      tableData: [],
      loading: false,
      allagent: false,
      pageSize: 20,
      page: 1,
      totalItem: 0,
      totalIncomeInSession: 0,
      totalABProfitInSession: 0,
      totalComissionInSession: 0,
      currency: "GBP",
    };
  },
  methods: {
    getComissionWhitelabel() {
      this.loading = true;

      let query = {
        from_date: this.start_date,
        to_date: this.end_date,
        page: this.page,
        items_per_page: this.pageSize,
        order: "desc",
      };

      let agent = this.company;
      if(this.allagent){
        agent = 'all'
      }
      comissionWhitelabel(agent, this.currency, query).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.totalItem = data.pagingData.totalItem;
            this.tableData = data.pagingData.records;
            this.totalIncomeInSession = data.totalIncomeInSession;
            this.totalABProfitInSession = data.totalABProfitInSession;
            this.totalComissionInSession = data.totalComissionInSession;
          }
        }
      );
    },
    setPage(val) {
      this.page = val;
      this.getComissionWhitelabel();
    },
    setPageSize(val) {
      this.pageSize = val;
      this.getComissionWhitelabel();
    },
  },
  created() {},
};
</script>

<style lang="scss">
.whitelabel-conmission-container {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
    }
  }

  .pagination-comission {
    margin-top: 10px;
  }
  .card-total{
    background-color: #ecf5ff;
  }
  .total{
    font-size: 1rem;
    font-weight: 700;
    color: #606266;
    span{
      color: #409eff;
    }
  }
}
</style>
